import React from 'react';
import { DiamondIcon } from './Icons';
export const SymptomsChecklist = () => {
  const symptoms = ['You wake up already tired — even after a full night of sleep', 'Your energy disappears halfway through the day', 'Your mind feels foggy — you lose your train of thought mid-sentence', 'You feel inflamed or bloated for no clear reason', 'You wake at 3am with your mind racing', "Your moods shift in ways you don't recognize", 'Weight settles around your middle, no matter what you do', 'Your cycle has become unpredictable, painful, or simply different', "You feel like you're surviving — not living"];
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-186">
      <div className="max-w-[780px] mx-auto" data-id="element-187">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-188">
          Do Any of These Feel Familiar?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-189">
          {symptoms.map((symptom, index) => <div key={index} className="bg-white border-l-[4px] border-medium rounded-[8px] p-4 md:px-5 md:py-4 shadow-[0_2px_8px_rgba(149,125,173,0.12)] flex items-start gap-3" data-id="element-190">
              <div className="mt-1 flex-shrink-0" data-id="element-191">
                <DiamondIcon color="#957DAD" size={16} data-id="element-192" />
              </div>
              <p className="font-lato text-[16px] text-body leading-snug" data-id="element-193">
                {symptom}
              </p>
            </div>)}
        </div>

        <div className="bg-medium rounded-[12px] py-6 px-8 mt-8 text-center" data-id="element-194">
          <p className="font-lato font-bold text-[18px] text-white leading-relaxed" data-id="element-195">
            If three or more of these feel familiar, you're not imagining it.
            <br data-id="element-196" />
            Your body has been quietly asking for support — and there is a
            calmer way forward.
          </p>
        </div>
      </div>
    </section>;
};